import { Fragment } from 'react'

import { EntityProfileHeaderInfoItemBase } from '../EntityProfileHeaderInfoItemBase'

import {
  ENTITY_PROFILE_HEADER_INFO_ITEMS_LOADING_ITEMS_LENGTH,
  ENTITY_PROFILE_HEADER_INFO_ITEMS_MAX_ITEMS_IN_ROW,
  ENTITY_PROFILE_HEADER_INFO_ITEMS_MAX_LOADING_ITEMS_IN_ROW,
} from './EntityProfileHeaderInfoItems.constants'

import * as styles from './EntityProfileHeaderInfoItems.module.css'

function EntityProfileHeaderInfoItems({
  className = styles.EntityProfileHeaderInfoItems,
  handlers,
  isLoading,
  itemActionsProps,
  items,
  loadingItemsLength = ENTITY_PROFILE_HEADER_INFO_ITEMS_LOADING_ITEMS_LENGTH,
  maxItemsInRow = ENTITY_PROFILE_HEADER_INFO_ITEMS_MAX_ITEMS_IN_ROW,
  maxLoadingItemsInRow = ENTITY_PROFILE_HEADER_INFO_ITEMS_MAX_LOADING_ITEMS_IN_ROW,
  renderItem,
}) {
  return (
    <div
      className={className}
      style={{
        '--profile-header-info-item-count': isLoading
          ? maxLoadingItemsInRow
          : maxItemsInRow,
      }}
    >
      {isLoading ? (
        <>
          {Array.from({ length: loadingItemsLength }).map((_, index) => (
            <EntityProfileHeaderInfoItemBase isLoading key={index} />
          ))}
        </>
      ) : (
        items?.map(item => (
          <Fragment key={item.name}>
            {renderItem({
              ...item,
              handlers: handlers?.[item.name],
              itemActionsProps,
            })}
          </Fragment>
        ))
      )}
    </div>
  )
}

export default EntityProfileHeaderInfoItems
